<template>
  <ZnModal
    :show="props.showModal"
    data-test="switch-catalog-modal"
    content-class="py-0 !px-0 bottom-0"
    :show-close-icon="false"
    size="find-size"
    @close="emit('close')"
  >
    <template #body>
      <div class="flex flex-col gap-8 p-6">
        <h2 class="text-center text-lg font-semibold">
          Choose Your Glasses Type
        </h2>
        <div class="flex flex-1 flex-col gap-4 lg:flex-row">
          <div
            v-for="catalog in guestCatalogs"
            :key="catalog.code"
            :data-test="`catalog-${catalog.code}-card`"
            class="flex cursor-pointer flex-col items-center gap-8 rounded-md p-6"
            :class="`${
              selected === catalog.code
                ? 'ring-teal-primary ring-2'
                : 'ring-grays-light shadow-[0px_0px_10px_0px_rgba(0,_0,_0,_0.25)] ring'
            }`"
            @click="selected = catalog.code"
          >
            <div class="flex min-h-28 flex-col gap-2">
              <div class="flex items-start justify-between gap-2">
                <h3 class="hidden text-xl font-semibold lg:block">
                  {{ catalog.title }}
                </h3>
                <NuxtImg class="lg:hidden" :src="catalog.img" width="135" />
                <div
                  v-if="selected === catalog.code"
                  class="shrink-0 grow-0 basis-8"
                >
                  <ZenniIconsIconSwitchCatalogCheck size="lg" />
                </div>
                <div
                  v-else
                  class="ring-grays-light block h-8 w-8 shrink-0 grow-0 basis-8 rounded-full ring-1"
                ></div>
              </div>
              <h3 class="pt-2 text-xl font-semibold lg:hidden">
                {{ catalog.title }}
              </h3>
              <span class="text-sm">{{ catalog.subTitle }}</span>
            </div>
            <NuxtImg class="hidden lg:block" :src="catalog.img" width="200" />
          </div>
        </div>
        <div class="flex flex-col gap-6">
          <ZnButton
            :type="selected ? 'primary' : 'gray'"
            class="w-full text-center"
            data-test="shop-now-button"
            @click="emitSelectedAndClose"
          >
            <span class="hidden lg:block">Shop Now</span>
            <span class="lg:hidden">Continue</span>
          </ZnButton>
          <SwitchCatalogSignInLegend
            v-if="!hideSignIn"
            class="hidden lg:block"
            @close="$emit('close')"
          />
        </div>
      </div>
    </template>
  </ZnModal>
</template>
<script setup lang="ts">
import { ref } from '#imports'
import { guestCatalogs } from '~/store/onboard'

const emit = defineEmits(['close', 'catalog-selected'])
const props = defineProps({
  showModal: {
    type: Boolean,
    required: true,
    default: () => false,
  },
  hideSignIn: {
    type: Boolean,
    default: () => false,
  },
})

const selected = ref<'vision' | 'safety' | null>(null)
const emitSelectedAndClose = () => {
  if (!selected.value) return
  emit('catalog-selected', selected.value)
  emit('close')
}
</script>
